import React, { useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Form,
  UncontrolledAlert,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { AppDispatch } from "src";
import { useDispatch, useSelector } from "react-redux";
import { addUnitUsers } from "src/slices/UnitsUsers/thunk";
import { useNavigate } from "react-router-dom";
import useToast from "src/components/Common/toast";

const NormalValidation = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { show, ToastComponent } = useToast();
  const units = useSelector((state: any) => state.units.units);
  const users = useSelector((state: any) => state.users.users);
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const userId = urlParams.get("user");
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      user: "",
      unit: "",
      level: "",
    },
    validationSchema: Yup.object({
      user: Yup.string().required("Por favor, selecione um utilizador"),
      unit: Yup.string().required("Por favor, selecione um orgão"),
      level: Yup.number().required("Por favor, selecione um nível"),
    }),
    onSubmit: async values => {
      await dispatch(addUnitUsers(values)).then(response => {
        if (
          typeof response.payload === "string" &&
          response.payload.includes("Request failed with")
        ) {
          show("Erro", "Erro ao atribuir usuario a um orgão");
        } else {
          show("Sucesso", "Usuario atribuido a um orgão com sucesso");
          validation.resetForm();
        }
      });
      if (userId) {
        navigate(`/users/${userId}`);
      }
    },
  });

  useEffect(() => {
    if (userId) {
      validation.setFieldValue("user", userId);
    }
  }, []);

  return (
    <React.Fragment>
      {ToastComponent}
      <Col>
        <Card>
          <CardBody>
            <Form
              className="needs-validation"
              onSubmit={e => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom04">Nome</Label>
                  <Input
                    name="user"
                    placeholder="Insira o nome do u tilizador"
                    type="select"
                    className="form-control"
                    id="validationCustom04"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.user || ""}
                    invalid={
                      validation.touched.user && validation.errors.user
                        ? true
                        : false
                    }
                  >
                    <option value="">Selecione</option>
                    {users.map((user: any) => (
                      <option value={user.id} key={user.id}>
                        {user.first_name} {user.last_name}
                      </option>
                    ))}
                  </Input>
                  {validation.touched.user &&
                  typeof validation.errors.user === "string" ? (
                    <FormFeedback type="invalid">
                      {validation.errors.user}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom03">Orgão de Estrutura</Label>
                  <Input
                    name="unit"
                    placeholder="Insira o nome do orgão de estrutura"
                    type="select"
                    className="form-control"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.unit || ""}
                    invalid={
                      validation.touched.unit && validation.errors.unit
                        ? true
                        : false
                    }
                  >
                    <option value="">Selecione</option>
                    {units.map((unit: any) => (
                      <option value={unit.id} key={unit.id}>
                        {unit.name}
                      </option>
                    ))}
                  </Input>
                  {validation.touched.unit && validation.errors.unit ? (
                    <FormFeedback type="invalid">
                      {validation.errors.unit}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom04">Nível</Label>
                  <Input
                    name="level"
                    placeholder="Nível"
                    type="select"
                    className="form-control"
                    id="validationCustom04"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.level || ""}
                    invalid={
                      validation.touched.level && validation.errors.level
                        ? true
                        : false
                    }
                  >
                    <option value="">Selecione</option>
                    <option value="1">Nivel 1</option>
                    <option value="2">Nivel 2</option>
                    <option value="3">Nivel 3</option>
                    <option value="4">Nivel 4</option>
                    <option value="5">Nivel 5</option>
                    <option value="6">Nivel 6</option>
                  </Input>
                  {validation.touched.level && validation.errors.level ? (
                    <FormFeedback type="invalid">
                      {validation.errors.level}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
              <Button color="primary" type="submit">Salvar</Button>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default NormalValidation;
